export const cell = ({ theme: { colors }, textAlign }) => ({
    color: colors.text,
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.2px',
    lineHeight: 1.56,
    textAlign,
});
